import { States } from 'src/app/enums/States';
import { SelectorPage } from '../../Modales/Selector/selector/selector.page';
import { Field } from '../Field/field';
import { ModulesManagerService } from "../Module/modules-manager.service";
import { Ask } from '../Ask/ask.service';
import { SelectorUtils } from '../../utils/selector-utils';

export class SelectorField extends Field {

    constructor(manager: ModulesManagerService, Data = null) {
        super(manager, Data)
    }

    /** @ovveride */
    protected async OnHydrated() {
        this.FixChoiciesDatasTypes()
        this._value = parseInt(this._value)
        await super.OnHydrated()
    }

    get ValueCss(): string {
        return this.selected() == null ? "color:rgb(128 128 128);" : ""
    }

    private FixChoiciesDatasTypes() {
        this.choices.map((data) => {
            data.locked = data.locked == "true"
            data.value = parseInt(data.value)
            data.parentValue = parseInt(data.parentValue)

        })
    }

    /**
     * Vérifie si des choix sont disponibles pour ce champ
     * @returns true si au moins un choix n'est pas locked et visible, false sinon
     */
    private hasAvailableChoices(): boolean {
        // Vérifier que le champ a une ask courante pour les filtres de visibilité
        if (!this.currentAsk) {
            return this.Choices.some(choice => !choice.locked);
        }

        // Filtrer les choix visibles selon les filtres (linkedTo)
        const visibleChoices = this.Choices.filter(choice =>
            SelectorUtils.isVisible(choice, this.currentAsk)
        );

        // Vérifier qu'au moins un choix visible n'est pas locked
        return visibleChoices.some(choice => !choice.locked);
    }

    /**
     * Surcharge de CanEdit pour vérifier la disponibilité des choix
     * @override
     */
    get CanEdit(): boolean {
        // Vérifier d'abord les conditions de base (héritées de Field)
        if (!super.CanEdit) return false;

        // Pour les champs selector, vérifier la disponibilité des choix
        if (!this.hasAvailableChoices()) {
            return false;
        }

        return true;
    }



    get ChoicesModel() {
        return this.Choices.map(choice => choice.value)
    }

    get Choices() {
        if (this.TargetField == "State") {
            let choices = []
            choices.push({
                locked: true,
                value: States.Creating,
                parentValue: -1,
                fullParentLabel: "",
                label: "STR_CREATING",
            })
            choices.push({
                locked: true,
                value: States.New,
                parentValue: -1,
                fullParentLabel: "",
                label: "STR_NEW",
            })
            choices.push({
                locked: false,
                value: States.Todo,
                parentValue: -1,
                fullParentLabel: "",
                label: "STR_TODO",
            })
            choices.push({
                locked: false,
                value: States.Running,
                parentValue: -1,
                fullParentLabel: "",
                label: "STR_RUNNING",
            })
            choices.push({
                locked: false,
                value: States.Over,
                parentValue: -1,
                fullParentLabel: "",
                label: "STR_OVER",
            })
            choices.push({
                locked: true,
                value: States.Archived,
                parentValue: -1,
                fullParentLabel: "",
                label: "STR_ARCHIVED",
            })
            return choices
        }
        return this.choices
    }

    private selected() {
        return this.Choices.find((data) => data.value == super.Value)
    }

    get Value(): any {

        let select = this.selected()
        // if(this.targetField =="arbo"){
        //     console.log(select, super.Value)
        // }
        if (select == null) return null
        let label = (select.fullParentLabel ? select.fullParentLabel + " " : "") + select.label
        if (this.TargetField == "equi" || this.TargetField == "C_Equi") {
            let Arbo = this.currentAsk?.getField({ TargetField: "C_Arbo" })
            if (Arbo)
                label = label.replace(Arbo.Value + " /", "")

        }
        return label
    }

    get StateNumber(): any {
        if (this.TargetField == "State") {
            return this.currentAsk?.State
        }
        return 0
    }

    set Value(value) {
        if (this.Choices.find(choice => choice.value == value)?.locked) {
            return;
        }
        if (this.TargetField == "State") {
            if (this.currentAsk != null) this.currentAsk.State = value
        }


        super.Value = value
    }

    async onEvent(event: any) {
        this.Value = event.detail.value
    }

    private onSelect(content) {

        this.Value = content.value
        //this.manager.closeModal()        
    }

    private async getLowestLevel() {
        if (this.TargetField == "C_Equi" || this.TargetField == "equi") {
            let arbo: Field = this.currentAsk?.getField({ TargetField: "C_Arbo" })
            if (arbo) {
                return arbo.orginialValue
            }
        }
        return 0
    }

    async onClick(...args: any[]): Promise<any> {
        if (!this.CanEdit) return;
        // console.log(this)
        this.openModal(this.Label, this.value)
    }

    /**
    * used for verifi is that field is valide for filter
    * @override
    * @param lookingFor string to search on field
    * @returns true if valide or false if not
    */
    public isFilterValid(lookingFor: string): boolean {
        if (this.TargetField == "State") {
            let State: any = this.manager.GetStateByName(lookingFor)
            if (State == null) return false
            return this.Value == "STR_" + (State as string).toUpperCase()
        }
        return super.isFilterValid(lookingFor)
    }

    private async openModal(title, value = 0) {
        let lowestLevel = await this.getLowestLevel()
        await this.manager.displayModal({
            component: SelectorPage,
            componentProps: {
                title: title,
                contents: this.Choices,
                selected: !value ? lowestLevel : value,
                targetField: this.targetField,
                currentAsk: this.currentAsk,
                lowestLevel: lowestLevel,
                callBack: this.onSelect.bind(this)
            },
            cssClass: "transparent-modal rounded-modal",
            breakpoints: [0, 0.25, 0.5, 0.75, 1],
            initialBreakpoint: this.Choices.length > 3 ? 1 : 0.5
        })
    }

    /** @override */
    async postRenderHtml(ask: Ask, args?: any): Promise<any> {
        await super.postRenderHtml(ask, args)
        if (this.TargetField == "C_Equi" || this.TargetField == "equi") {
            let arbo: Field = this.currentAsk?.getField({ TargetField: "C_Arbo" })
            let old_value = this.value
            if (arbo && !arbo.Value)
                arbo.Value = this.selected()?.parentValue || 0
            this.value = old_value
        }
    }
}
